import {
  AppConnectMasterRaw,
  AppConnectMasterRawForm,
} from "@/domain/AppConnectMasters";
import { API_CLIENT } from "../config";
import { getAPIConfigs } from "../helpers";

const apiUrl = "/connect_addons/advanced";

// AppConnectMaster一覧を取得する
export const getAppConnectMasters = async ({
  organizationId,
}: {
  organizationId: string;
}): Promise<AppConnectMasterRaw[]> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.get<{ items: AppConnectMasterRaw[] }>(
    apiUrl,
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.items;
};

// AppConnectMasterを更新する
export const postEditAppConnectMaster = async ({
  connect_master_id,
  appConnectMasterRawForm,
  organizationId,
}: {
  connect_master_id: string;
  appConnectMasterRawForm: AppConnectMasterRawForm;
  organizationId: string;
}): Promise<AppConnectMasterRaw> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.post<{ item: AppConnectMasterRaw }>(
    `${apiUrl}/${connect_master_id}`,
    {
      ...appConnectMasterRawForm,
    },
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.item;
};

// AppConnectMasterの共通シークレット変数を取得する
export const getAppConnectMasterCommonSecrets = async ({
  connect_master_id,
  organizationId,
}: {
  organizationId: string;
  connect_master_id: string;
}): Promise<{ [k: string]: string }> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.get<{ item: { [k: string]: string } }>(
    `${apiUrl}/${connect_master_id}/common_secrets`,
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.item;
};

// AppConnectMasterの共通シークレット変数を更新する
export const postAppConnectMasterCommonSecrets = async ({
  connect_master_id,
  item,
  organizationId,
}: {
  organizationId: string;
  connect_master_id: string;
  item: { [k: string]: string };
}): Promise<{ [k: string]: string }> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.post<{ item: { [k: string]: string } }>(
    `${apiUrl}/${connect_master_id}/common_secrets`,
    { item },
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.item;
};
